export const OrdersIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-macaw-ui-candidate
  >
    <path
      d="M4.167 6.667v9.166h11.666V6.667h-2.5v5.312c0 .32-.132.56-.396.72a.791.791 0 0 1-.812.03L10 11.667l-2.125 1.062a.793.793 0 0 1-.813-.031.785.785 0 0 1-.395-.718V6.667h-2.5Zm0 10.833c-.459 0-.851-.163-1.178-.49a1.602 1.602 0 0 1-.489-1.177V5.437a1.7 1.7 0 0 1 .094-.562 1.64 1.64 0 0 1 .281-.5l1.042-1.27c.152-.195.343-.345.572-.45.23-.104.469-.156.72-.155h9.583c.25 0 .49.052.719.157.23.104.42.253.572.447l1.042 1.271a1.631 1.631 0 0 1 .375 1.063v10.395c0 .459-.163.851-.49 1.178-.327.326-.719.49-1.177.489H4.167ZM4.5 5h11l-.708-.833H5.208L4.5 5Zm3.833 1.667v3.958L10 9.792l1.667.833V6.667H8.333Z"
      fill="currentColor"
    />
  </svg>
);
